export default __webpack_public_path__ + "static/media/destination-grid-320_385-KanhaPench-National-Park.803875af.png";